// extracted by mini-css-extract-plugin
export var button = "_nf-2";
export var card = "_nf-0";
export var closeButtonContainer = "_nf-3";
export var iconContainer = "_nf-1";